import Wprr from "wprr";
import React from "react";
import Dbm from "dbm";
import ImageGallerySection from "./ImageGallerySection";

export default class ImageGallery extends Wprr.BaseObject {
	
	_construct() {
		super._construct();
	}

	getImageGroups(aArray) {

		let images = this.getFirstInput("images", Wprr.sourceReference("blockData", "images"));
		let groups = Dbm.utils.ArrayFunctions.splitArray(images, 4);

		let length = groups.length;
		if(length > 1 && groups[length - 1].length === 1) {
			let last = groups[length-1];
			let prev = groups[length-2];

			let lastInPrevious = prev.pop();
			last.unshift(lastInPrevious);
		}

		return groups;
	}

	_renderMainElement() {
		
		let elements = [];

		let currentArray = this.getImageGroups();
		let currentArrayLength = currentArray.length;
		for(let i = 0; i < currentArrayLength; i++) {
			if(i !== 0) {
				elements.push(<div key={"spacing-" +i} className="spacing medium" />);
			}
			elements.push(<ImageGallerySection key={i} images={currentArray[i]} />);
		}
		
		return <div className="centered-site">
			{elements}
		</div>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};

        let newItemTemplate = {
            image: null,
        };

        let itemMarkup = (
            <div>
				<Wprr.EditableProps
					editableProps={Wprr.source("combine", ["images.", Wprr.sourceReference("loop/array/index"), ".image"])}
					externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")}
				>
					<Wprr.wp.blocks.editor.ImageSelection
						className="full-width"
						valueName={Wprr.source("combine", ["images.", Wprr.sourceReference("loop/array/index"), ".image"])}
					/>
				</Wprr.EditableProps>
            </div>
        );

        let spaceMarkup = <div className="spacing small" />;
		
		return <Wprr.layout.admin.WpBlockEditor dataSettings={dataSettings}>
			<div>
                <label>{Wprr.translateText("Images")}</label>
                <Wprr.EditableProps editableProps="images" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")}>
                    <Wprr.ArrayEditor valueName="images" newItemTemplate={newItemTemplate} editItemMarkup={itemMarkup} loopItemSpacingMarkup={spaceMarkup} />
                </Wprr.EditableProps>
            </div>
		</Wprr.layout.admin.WpBlockEditor>;
	}
}